export const handTypes = [
	{
		name: 'Passive/body-powered',
		slug: 'passive-hand',
		image_uri: {
			image_1x: '/img/hand-types/symbious1.png',
			image_2x: '/img/hand-types/symbious1@2x.png',
			image_3x: '/img/hand-types/symbious1@3x.png',
		},
	},
	{
		name: 'Bionic',
		slug: 'bionic-hand',
		image_uri: {
			image_1x: '/img/hand-types/glaze-whizzlink-zeus2-v2.png',
			image_2x: '/img/hand-types/glaze-whizzlink-zeus2-v2@2x.png',
			image_3x: '/img/hand-types/glaze-whizzlink-zeus2-v2@3x.png',
		},
	},
];

/**
 * Jakie typy rąk widzi protetyk dla DANEGO produktu.
 *
 * Łokcie Espire mają twarde ograniczenia fizyczne, nie preferencje. Pro i Hybrid przyjmują
 * wyłącznie Quick Disconnect Wrist, więc terminal z gwintem NIE ZAMONTUJE SIĘ na nich —
 * zamówienie z ręką mechaniczną byłoby niewykonalne, a dowiedzielibyśmy się o tym dopiero
 * na produkcji. Classic z kolei nie ma sterowania mioelektrycznego.
 *
 * Matryca od Alicji (korekta z 29.09 do dokumentu „Zmiany w I'AM App 09.26" — w samym
 * dokumencie Pro i Hybrid miały błędnie dopuszczone ręce pasywne):
 *
 * | model | dozwolone ręce |
 * | -- | -- |
 * | Espire™ Elbow Pro | tylko mioelektryczne |
 * | Espire™ Elbow Hybrid | tylko mioelektryczne |
 * | Espire™ Elbow Classic Plus | mioelektryczne + pasywne/mechaniczne |
 * | Espire™ Elbow Classic | tylko pasywne/mechaniczne |
 *
 * Wybór typu ręki NIE jest zapisywany w zamówieniu — steruje tym, czy protetyk trafia na wybór
 * ręki bionicznej, czy terminala. Usunięta opcja odcina całą gałąź kreatora.
 *
 * UWAGA — to jest bramka INTERFEJSU, nie bramka API. Wcześniejsze brzmienie tego komentarza
 * mówiło „pełna bramka" i było NIEPRAWDZIWE (wskazała Rita): `BionicHandOrderRequest` waliduje
 * wyłącznie `exists:bionic_hands,id`, więc spreparowane żądanie dopnie rękę mioelektryczną do
 * Espire™ Elbow Classic, który nie ma sterowania mioelektrycznego. Ryzyko jest niskie (narzędzie
 * B2B), ale następny deweloper nie może polegać na tym zdaniu. Walidacja po stronie API idzie
 * razem z walidacją typu amputacji w GLA-86, po targach.
 *
 * Druga strona tej reguły to DANE: `terminals.json` i `bionic-hands.json` muszą mieć dla każdego
 * dozwolonego typu co najmniej jedną pozycję i żadnej dla niedozwolonego. Pilnuje tego
 * `tests/unit/constants/handMatrixMatchesCatalog.spec.ts` — bez niego obie strony rozjeżdżają się
 * po cichu, a protetyk trafia na pustą listę przy zielonej bramce.
 */
export const HAND_TYPES_BY_PROSTHESIS: Record<string, string[]> = {
	'espire-pro-above': ['bionic-hand'],
	'espire-hybrid-above': ['bionic-hand'],
	'espire-classic-plus-above': ['bionic-hand', 'passive-hand'],
	'espire-classic-above': ['passive-hand'],
};

export function handTypesForProsthesis(prosthesisSlug?: string | null): typeof handTypes {
	const allowed = prosthesisSlug ? HAND_TYPES_BY_PROSTHESIS[prosthesisSlug] : undefined;

	if (!allowed) {
		return [...handTypes];
	}

	return handTypes.filter(type => allowed.includes(type.slug));
}

const PASSIVE_WITHOUT_DEVICE_PRODUCTS: string[] = ['glaze-basic-below'];

/**
 * GLA-121: w GBB „Passive/body-powered” bez zaznaczonego urządzenia to kompletny wybór
 * sprzed GLA-121 (kryterium 3).
 * Sygnatura przyjmuje sam slug, jak `espireShowsExtraParameters`, więc nie da się jej podać
 * stanu zamówienia. Espire zachowuje regułę GLA-89: „nic” wraca na wybór.
 */
export function allowsPassiveWithoutDevice(prosthesisSlug?: string | null): boolean {
	return !!prosthesisSlug && PASSIVE_WITHOUT_DEVICE_PRODUCTS.includes(prosthesisSlug);
}
